import { createSelector } from '@ngrx/store';
import {
	assetEntitySelector,
	IIfcAssetsState,
} from '@app/pages/cmms/components/assets/state/assets.reducer';
import { AuUtilsFunctions } from '@app/shared';
import {
	defaultPageSize,
	paginationQueryVariables,
} from '@app/pages/cmms/configs/pagination-query-variables';

export const selectAssetState = state => state.cmms.assetState;

export const assetEntities = createSelector(
	selectAssetState,
	assetEntitySelector.selectEntities
);

export const needReloadAsset = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.needReloadAsset
);

export const allAssets = createSelector(selectAssetState, (state: IIfcAssetsState) => {
	return {
		assets: assetEntitySelector.selectAll(state),
		assetsPagination: state.assetsPagination,
	};
});

export const assetsAuPagination = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetAuPagination
);

export const assetsPageSize = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) =>
		state.assetAuPagination?.first ?? state.assetAuPagination?.last ?? defaultPageSize
);

export const assetsQueryVariables = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetsQueryVariables
);

export const assetsQueryVariablesWithoutPagination = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => {
		if (state.assetsQueryVariables) {
			return AuUtilsFunctions.excludeObjectKeys(
				state.assetsQueryVariables,
				paginationQueryVariables
			);
		}
	}
);

export const assetsTableColumnKeys = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => {
		return (state?.tableColumnsConfig ?? []).map(column => column.key);
	}
);

export const assetsTableExportUrlQuery = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.exportUrlQuery
);

export const assetsIsExportable = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.isExportable
);

export const assetsExportTableData = createSelector({
	isExportable: assetsIsExportable,
	queryVariables: assetsQueryVariablesWithoutPagination,
	columnKeys: assetsTableColumnKeys,
	exportUrlQuery: assetsTableExportUrlQuery,
});

export const measurementExportTableData = createSelector(
	assetsExportTableData,
	exportTableData => {
		return {
			...exportTableData,
			columnKeys: [
				'name',
				'location',
				'measurementName',
				'measurementDate',
				'measurementTime',
				'measurementValue',
				'measurementSettingsLowerValue',
				'measurementSettingsUpperValue',
				'measurementSettingsTargetValue',
				'measurementSettingsUnitValue',
				'measurementValueUpdatedBy',
			],
		};
	}
);

export const assetsIsLoading = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetIsLoading
);

export const assetsTotal = createSelector(
	selectAssetState,
	assetEntitySelector.selectTotal
);

export const editedAsset = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetEdit
);

export const assetData = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetData
);

export const editedAssetPrimaryKey = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.assetEdit.pk
);

export const assetWorkspaceIsFromOutside = createSelector(
	selectAssetState,
	(state: IIfcAssetsState) => state.fromOutside
);
